(function() {
  const nav = document.getElementById('gl-nav');
  if (!nav) return;

  const dropdown = document.getElementById('gl-dropdown');
  const leftItems = nav.querySelectorAll('.gl-nav__left-item');
  const panels = nav.querySelectorAll('.gl-nav__panel');
  const topLinks = nav.querySelectorAll('.gl-nav__top-link');
  const hamburger = nav.querySelector('.gl-nav__hamburger');
  const right = nav.querySelector('.gl-nav__right');

  let closeTimer = null;
  let hoverTimer = null;
  let currentActive = null;

  function getHeaderHeight() {
    const header = document.getElementById('header');
    if (header) return header.offsetHeight;
    return 80;
  }

  function activatePanel(index) {
    currentActive = index;
    leftItems.forEach(i => i.classList.remove('is-active'));
    panels.forEach(p => p.classList.remove('is-active'));
    topLinks.forEach(l => l.classList.remove('is-active'));

    const targetLeft = nav.querySelector(`.gl-nav__left-item[data-index="${index}"]`);
    const targetPanel = nav.querySelector(`.gl-nav__panel[data-panel="${index}"]`);

    if (targetLeft) targetLeft.classList.add('is-active');
    if (targetPanel) targetPanel.classList.add('is-active');

    topLinks.forEach(link => {
      if (link.dataset.menuIndex == index) link.classList.add('is-active');
    });
  }

  function openDropdown(index) {
    clearTimeout(closeTimer);
    const headerSection = document.querySelector('.header-section');
    if (headerSection) {
      dropdown.style.top = headerSection.offsetTop + headerSection.offsetHeight + 'px';
    }
    dropdown.classList.add('is-open');
    activatePanel(index !== undefined ? index : 0);
  }

  function closeDropdown() {
    closeTimer = setTimeout(() => {
      dropdown.classList.remove('is-open');
      document.body.style.overflow = '';
      currentActive = null;
      leftItems.forEach(i => i.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));
      topLinks.forEach(l => l.classList.remove('is-active'));
    }, 150);
  }

  // Hamburgar
  hamburger.addEventListener('mouseenter', () => openDropdown(0));
  hamburger.addEventListener('mouseleave', closeDropdown);

  // Utskrivna top-länkar — med 200ms fördröjning så diagonal mus inte triggar fel panel
  topLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        openDropdown(parseInt(link.dataset.menuIndex));
      }, 200);
    });
    link.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
      closeDropdown();
    });
  });

  // Vänster items — med 120ms fördröjning för diagonal rörelse
  leftItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        activatePanel(parseInt(item.dataset.index));
      }, 120);
    });
    item.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
    });
  });

  // Håll dropdown öppen när musen är i den
  dropdown.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
    clearTimeout(hoverTimer);
  });
  dropdown.addEventListener('mouseleave', closeDropdown);

  // Stäng vid klick utanför
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Stäng vid Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      dropdown.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
})();